import {
    PRODUCT_FAILED, PRODUCT_LOADING, PRODUCT_REMOVE, PRODUCT_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    product: null,
    request: null,
};

export const productCrudReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any }
) => {
    switch (action.type) {
        case PRODUCT_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                product: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case PRODUCT_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request

            };
        case PRODUCT_REMOVE:
            return initialState

        default:
            return state;
    }
};

